import type { Profile } from "./profile.types";

export function getFullName(profile: Pick<Profile, "firstName" | "middleName" | "lastName"> | null): string | null {
  if (!profile) return null;
  return [profile.firstName, profile.middleName, profile.lastName].filter(Boolean).join(" ");
}
